export enum PlatformCapability {
    Mail = 'MAIL',
    SyncFiles = 'FILE_SYNC',
    SyncUsers = 'USER_SYNC',
}
